<script setup lang="ts">
import Editor from "~/components/Common/Rich-text-editor/Editor.vue";

const props = defineProps(["modelValue", "placeHolder", "disabled"]);
const emit = defineEmits(["update:modelValue"]);

const value = computed({
  get() {
    return props.modelValue;
  },
  set(value) {
    emit("update:modelValue", value);
  },
});
</script>

<template>
  <div class="w-full flex flex-col gap-2">
    <slot name="title">Title</slot>
    <Editor
      v-model="value"
      :disabled="disabled"
      :actions-list="[
        'default',
        'list',
        'blockquote',
        'separator',
        'justify',
        'text-style',
        'color-text',
        'link',
        // 'image',
        // 'table'
      ]"
    />
  </div>
</template>

<style lang="scss"></style>
